var metric, imperial;

metric = {
  Nm: {
    name: {
      singular: "Newton-meter",
      plural: "Newton-meters",
    },
    to_anchor: 1,
  },
   cNm: {
    name: {
      singular: "centi Newton-meter",
      plural: "centi Newton-meters",
    },
    to_anchor: 0.01, // 1 cNm = 0.01 Nm
  },
  kgfM: {
    name: {
      singular: "Kilogram-force Meter",
      plural: "Kilogram-force Meters",
    },
    to_anchor: 9.80665,
  },
  kgfcm: {
    name: {
      singular: "Kilogram-force Centimeter",
      plural: "Kilogram-force Centimeters",
    },
    to_anchor: 0.0980665, // 1 kgf·cm = 0.0980665 Nm
  },
};

imperial = {
  "Lbf.in": {
    name: {
      singular: "Pound Force-Inch",
      plural: "Pound Force-Inches",
    },
    to_anchor: 1 / 12,
  },
  "Lbf.ft": {
    name: {
      singular: "Pound Force-Foot",
      plural: "Pound Force-Feet",
    },
    to_anchor: 1, // Pound Force-Foot as a base unit
  },
};

module.exports = {
  metric: metric,
  imperial: imperial,
  _anchors: {
    metric: {
      unit: "Nm",
      ratio: 1 / 0.737562,
    },
    imperial: {
      unit: "ftlb",
      ratio: 0.737562,
    },
  },
};
